export const FAQArray = [
  {
    header: 'About Tata Neu HDFC Bank Credit Card',
    data: [
      {
        header: '',
        data: `<ol>
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is Tata Neu HDFC Bank Credit Card?</span></span></span></p>
          </li>
          </ol>
          <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">The Tata Neu</span></span><span style=""><span style="" class="faqspan"><span> </span></span></span><span style=""><span style="" class="faqspan">HDFC Bank Credit</span></span><span style=""><span style="" class="faqspan"><span> </span></span></span><span style=""><span style="" class="faqspan">Card is a co-brand credit card launched in partnership with HDFC Bank. The Tata Neu HDFC Bank Credit</span></span><span style=""><span style="" class="faqspan"><span> </span></span></span><span style=""><span style="" class="faqspan">Card will have two variants:</span></span></p>
          <ol>
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">Tata Neu Infinity HDFC Bank Credit Card</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Tata Neu Plus HDFC Bank Credit Card</span></span></p>
          </li>
          </ol>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">For detailed Terms and Conditions please visit HDFC Bank&rsquo;s Most Important Terms &amp; Conditions </span></span><span style="color: #ed7d31;"><span style=""><span style="" class="faqspan"><a style="color: white;" href='https://www.hdfcbank.com/content/bbp/repositories/723fb80a-2dde-42a3-9793-7ae1be57c87f/?path=/Personal/Pay/Cards/Credit%20Card/Credit%20Card%20Landing%20Page/Manage%20Your%20Credit%20Cards%20PDFs/MITC%201.64.pdf'>Click Here</a></span></span></span></p>
          <ol start="2">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What are the annual membership charges on Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">The following charges apply:</span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">Joining fees: INR 1499 + GST &amp; Renewal fees: INR 1499 + GST for Tata Neu Infinity HDFC Bank Credit Card</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Joining fees: INR 499 + GST &amp; Renewal fees: INR 499 + GST for Tata Neu Plus HDFC Bank Credit Card</span></span></p>
          </li>
          <li>
          <p><span style="color: #ff0000;"><span style=""><span style="" class="faqspan"><a style="color: white;" href="https://www.hdfcbank.com/content/bbp/repositories/723fb80a-2dde-42a3-9793-7ae1be57c87f/?path=/Personal/Pay/Cards/Credit%20Card/Credit%20Card%20Landing%20Page/Manage%20Your%20Credit%20Cards%20PDFs/MITC%201.64.pdf">Click here</a> </span></span></span><span style=""><span style="" class="faqspan">to know about all the applicable charges </span></span></p>
          </li>
          </ol>
          </li>
          </ol>`
      }
    ]
  },
  {
    header: 'Eligibility criteria for Tata Neu HDFC Bank Credit Card?',
    data: [
      {
        header: '',
        data: `<p class="faqspan">The Tata Neu<strong>&nbsp;</strong>HDFC Bank Credit<strong>&nbsp;</strong>Card is a co-brand credit card launched in partnership with HDFC Bank. It is available for all Tata Neu customers.</p>
                <ul type="disc">
                <li><span class="faqspan">The applicant must be a Salaried Professional, Self-Employed Professional or Self-Employed Businessperson.</span></li>
                <li><span class="faqspan">Existing HDFC Bank Credit Card holders can also apply for this Card. The Credit Limit of existing HDFC Bank Credit Card will be shared with the Tata Neu HDFC Bank Credit Card.</span></li>
                </ul>
                <p><span class="faqspan">Eligibility condition for salaried customers:</span></p>
                <ol start="1" type="1">
                <li><span class="faqspan">Age group: 21-60 years</span></li>
                <li><span class="faqspan">Gross Monthly Income &gt; ₹ 25,000 for Tata Neu Plus HDFC Bank Credit Card.</span></li>
                <li><span class="faqspan">Gross Monthly Income &gt; ₹ 100,000 for Tata Neu Infinity HDFC Bank Credit Card.</span></li>
                </ol>
                <p><span class="faqspan">Eligibility condition for self-employed customers:</span></p>
                <ol>
                <li style="list-style-type: none;">
                <ol start="1" type="1">
                <li><span class="faqspan">Age group: 21-65 years</span></li>
                <li><span class="faqspan">Last year ITR &gt; ₹ 6 Lakhs per annum for Tata Neu Plus HDFC Bank Credit Card.</span></li>
                <li><span class="faqspan">Last year ITR &gt; ₹ 12 Lakhs per annum for Tata Neu Infinity HDFC Bank Credit Card.</span></li>
                </ol>
                </li>
                </ol>`
      }
    ]
  },
  {
    header: 'Getting Tata Neu HDFC Bank Credit Card',
    data: [
      {
        header: '',
        data: `<ol>
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is the process to get a Tata Neu HDFC Bank Credit Card?</span></span></span></p>
          </li>
          </ol>
          <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">The Tata Neu HDFC Bank Credit Card is issued by HDFC Bank in association with Tata Neu. Eligible customers can apply by following the below steps.</span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">Login to </span></span><span style=""><span style="" class="faqspan"><span>Tata Neu app &gt;&gt; Finance &gt;&gt; Credit Cards</span></span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Fill in the Tata Neu HDFC Bank Credit Card application form to check your eligibility</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Complete the verification process to get your Tata Neu HDFC Bank Credit Card.</span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <ol start="2">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is the Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card application completion window?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Your Tata Neu HDFC Bank Credit Card application once initiated must be completed within 10 days from the application start date.</span></span></p>
          <ol start="3">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>How do I track the status of my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card application and Card delivery?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Your application once submitted will be approved by HDFC Bank within 7 to 10 working days, subject to policy checks. Generally, the physical card shall be delivered at your delivery address given at the time of application within 3 working days of application approval.</span></span></p>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">To track your Tata Neu HDFC Bank Credit Card application and Card delivery, </span></span><span style=""><span style="" class="faqspan"><span>Login to Tata Neu app &gt;&gt; Finance &gt;&gt; Credit Cards</span></span></span><span style=""><span style="" class="faqspan">, to check the status of your Tata Neu HDFC Bank Credit Card.</span></span></p>
          <ol start="4">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>Where will my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card be delivered?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Your Tata Neu HDFC Bank Credit Card will be delivered to your card delivery address given during your application.</span></span></p>
          <ol start="5">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>My Tata Neu HDFC Bank Credit Card is undelivered, how can I request redelivery?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan">If you have not received the physical delivery of your Tata Neu HDFC Bank Credit Card, please call Tata Neu HDFC Bank Customer Care from your registered mobile number or write to us from your registered email id at the contacts below:</span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">In India: Call </span></span><span style=""><span style="" class="faqspan"><span>1800-25-8282-638</span></span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Email: </span></span><span style=""><span style="" class="faqspan"><span>customerservices.cards@hdfc.bank.in</span></span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <p class="western" style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan"><span>Explainer: </span></span></span><span style=""><span style="" class="faqspan">Bank attempts the delivery of your Tata Neu HDFC Bank Credit Card at your bank registered communication address. As per the process, 3 attempts are made within first 10 working days and if the card is still undelivered, then the card is sent back to HDFC Bank. If your Tata Neu HDFC Bank credit card is undelivered after 10 days from approval of the card, then please call HDFC Bank Phone Banking and request for re-dispatch of your Tata Neu HDFC Bank Credit Card.</span></span></p>
          <ol start="6">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is the process of Video KYC?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Instant online verification for your Credit Card Application through Aadhar and video call, checklist before you start Video KYC are:</span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">A blank white sheet of paper and a black or blue pen,</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">A well-lit room with a plain wall behind you,</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">A smartphone with stable mobile network connectivity,</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Original PAN Card </span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <ol start="7">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What documents do I need to complete a Video KYC?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You need the following documents during Video KYC: </span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">Aadhar card Number</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Original PAN card</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">A blank white sheet of paper and a black or blue pen,</span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <ol start="8">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What time is the Video KYC facility available for the Tata Neu HDFC Bank Credit Card?<!-- Please rephrase as:
          What time is the Video KYC facility available for Tata Neu HDFC Bank Credit Card? --><!-- Changes done --></span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Video KYC is available from 10 am to 12 am from Monday to Sunday.</span></span></p>
          <ol start="9">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is the validity of the VKYC Link for completing the VKYC process?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Your Video KYC link will be active for 72 hours. You will have to complete your Video KYC within 72 hours. </span></span></p>
          <ol start="10">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>Can I opt for physical pick-up of documents?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Yes, you can opt for physical pickup of documents as well. The bank executive will reach out to you for valid KYC document verification and documents pick-up.</span></span></p>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You need to keep photocopies of the following documents ready for physical pickup: </span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan"><span>Address proof &ndash; </span></span></span><span style=""><span style="" class="faqspan">Any one of the below documents can be provided</span></span></p>
          <ol type="a">
          <li>
          <p><span style=""><span style="" class="faqspan">Aadhar card</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Voter ID card</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Driving License</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Passport</span></span></p>
          </li>
          </ol>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Original PAN Card</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">Coloured passport size photograph</span></span></p>
          </li>
          </ol>
          </li>
          </ol>`
      }
    ]
  },
  {
    header: 'Using Tata Neu HDFC Bank Credit Card',
    data: [
      {
        header: '',
        data: `<ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How do I start using my Tata Neu HDFC Bank Credit Card for Online and In-store purchases?</span></span></span></p>
            </li>
            </ol>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can use your Tata Neu HDFC Bank Credit Card for online and in-store purchases as below:</span></span></p>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can still shop online even without having your physical card.</span></span></p>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>For Online Purchases: </span></span></span></p>
            </li>
            </ol>
            </ol>
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">Enable your online transactions via Card Controls/Manage Card.</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can do transaction online using your Tata Neu HDFC Bank Credit Card number, CVV and Card Expiry Date. Steps to view your Tata Neu HDFC Bank Credit Card details</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            </li>
            </ol>
            <ul>
            <li style="list-style-type: none;">
            <ul>
            <li style="list-style-type: none;">
            <ul>
            <li style="list-style-type: none;">
            <ul>
            <li>
            <p><span style=""><span style="" class="faqspan">Login to </span></span><span style=""><span style="" class="faqspan"><span>Tata Neu app &gt;&gt; Finance &gt;&gt; Credit Cards &gt;&gt; View card details, </span></span></span><span style=""><span style="" class="faqspan">you will be directed to the HDFC Bank page </span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter OTP sent to your registered mobile no. to check your Tata Neu HDFC Bank Credit Card details.</span></span></p>
            </li>
            </ul>
            </li>
            </ul>
            </li>
            </ul>
            </li>
            </ul>
            <ol>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>For In-store Purchases</span></span></span></p>
            </li>
            </ol>
            </ol>
            <p class="western" style="padding-left: 80px;"><span style=""><span style="" class="faqspan">Please generate your CARD PIN to make offline/instore purchases.</span></span></p>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How do I set / reset my Tata Neu HDFC Bank Credit Card PIN?</span></span></span></p>
            </li>
            </ol>
            <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Your Tata Neu HDFC Bank Credit Card PIN is required to compete your purchase transactions at offline Stores and cash withdrawal at ATMs.</span></span></p>
            <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can set / reset your Tata Neu</span></span><span style=""><span style="" class="faqspan"><span> </span></span></span><span style=""><span style="" class="faqspan">HDFC Bank Credit Card PIN via the below channels.</span></span></p>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>Tata Neu HDFC Bank Customer Care Number (For all Customers)</span></span></span></p>
            </li>
            </ol>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">Call 18602660333 (IVR) or 1800258282638 (Assisted by Executive) from your HDFC Bank registered mobile number to generate your Card PIN.</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Key in the last four digits of your Tata Neu </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>Card</span></span></span><span style=""><span style="" class="faqspan">.</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Validate with the OTP sent on your registered mobile number and reset your Tata Neu</span></span><span style=""><span style="" class="faqspan"><span> HDFC Bank Credit</span></span></span><span style=""><span style="" class="faqspan"> Card PIN.</span></span></p>
            </li>
            </ol>
            </ol>
            <p class="western">&nbsp;</p>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Mobile Banking (for customers with HDFC Bank A/c)</span></span></span></p>
            </li>
            </ol>
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">On your HDFC Mobile Banking App, click on </span></span><span style=""><span style="" class="faqspan"><span>Menu &gt;&gt; Cards &gt;&gt; Select Card No. &gt;&gt; Change PIN</span></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Type OTP which is sent to the registered mobile number and set your Card PIN</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="3">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Net Banking (for customers with HDFC Bank A/c)</span></span></span></p>
            </li>
            </ol>
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">After logging in HDFC Net Banking, click on </span></span><span style=""><span style="" class="faqspan"><span>Cards &gt;&gt; Credit Card &gt;&gt; Request &gt;&gt; Instant PIN Generation &gt;&gt; Card No. &gt;&gt; Set your 4-digit PIN</span></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Type OTP which is sent to the registered mobile number and set your Card PIN</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="3">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How can I manage the transactions of my Tata Neu HDFC Bank Credit Card?</span></span></span></p>
            </li>
            </ol>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can use your Tata Neu</span></span><span style=""><span style="" class="faqspan"><span> </span></span></span><span style=""><span style="" class="faqspan">HDFC Bank Credit Card once your application is approved. However, your newly issued Tata Neu HDFC Bank Credit Card is temporarily disabled for online, contactless, ATM and International transactions. You need to enabled online, contactless, ATM and International transactions to shop seamlessly.</span></span></p>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can check and manage the permissible transactions on your Tata Neu</span></span><span style=""><span style="" class="faqspan"><span> HDFC Bank Credit</span></span></span><span style=""><span style="" class="faqspan"> Card in the following ways:</span></span></p>
            <p>&nbsp;</p>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Bank MyCards:</span></span></span></p>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">Log in to </span></span><span style=""><span style="" class="faqspan">https://mycards.hdfc.bank.in</span></span><span style=""><span style="font-size: large;"> </span></span><span style=""><span style="" class="faqspan">using your registered mobile number</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter the OTP configured to your registered mobile number</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Click on &ldquo;Card Control&rdquo; service under Credit Cards. </span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can set and customise your credit card usage/limits</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter OTP configured to your registered mobile number to successfully make these changes.</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            </ol>
            <ol>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Bank Mobile Banking</span></span></span></p>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">On your HDFC Mobile Banking app, go to </span></span><span style=""><span style="" class="faqspan"><span>Menu &gt;&gt; Pay &gt;&gt; Cards &gt;&gt; Credit Card Number &gt;&gt; Show more &gt;&gt; Limits &amp; Restrictions</span></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can set and customise your credit card usage/limits</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter OTP configured to your registered mobile number to successfully make these changes.</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            </ol>
            <ol>
            <ol start="3">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Bank Net Banking</span></span></span></p>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">On your HDFC Net Banking, go to </span></span><span style=""><span style="" class="faqspan"><span>Cards &gt;&gt; Request &gt;&gt; Card Usage/Limits </span></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can set and customise your credit card usage/limits</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter OTP configured to your registered mobile number to successfully make these changes.</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            </ol>
            <ol start="4">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How can I pay my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>Card bill?</span></span></span></p>
            </li>
            </ol>
            <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can pay your Tata Neu HDFC Bank Credit Card bill in the following ways:</span></span></p>
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">You can pay using your HDFC Net Banking and HDFC Mobile Banking with your HDFC Bank account.</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can also pay using a non-HDFC Bank account via bill desk payment gateway: <a style="color: white;" href="https://www.billdesk.com/pgidsk/pgmerc/hdfccard/HDFC_card.jsp">https://www.billdesk.com/pgidsk/pgmerc/hdfccard/HDFC_card.jsp</a></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">For more on HDFC Bank Tata Neu HDFC Bank Credit Card bill payment please visit: <a style="color: white;" href="https://www.hdfc.bank.in/credit-cards/services/credit-cards-bill-payment">https://www.hdfc.bank.in/credit-cards/services/credit-cards-bill-payment</a></span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            <p>&nbsp;</p>
            <ol start="5">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How long does it take to process my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card bill payment?</span></span></span></p>
            </li>
            </ol>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">The amount authorised by you will be credited to your Tata Neu HDFC Bank Credit Card account within 3 working days, excluding weekends and bank holidays.</span></span></p>
            <p>&nbsp;</p>
            <ol start="6">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>Where can I find my unbilled transactions on Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>Card?</span></span></span></p>
            </li>
            </ol>
            <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Transactions made on the Tata Neu HDFC Bank Credit Card after your last Tata Neu HDFC Bank Credit Card bill statement are known as unbilled transactions. You can view your unbilled transactions by visiting HDFC MyCards or HDFC Net Banking or HDFC Mobile Banking:</span></span></p>
            <p class="western">&nbsp;</p>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC MyCards:</span></span></span></p>
            </li>
            </ol>
            </ol>
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li style="list-style-type: none;">
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">Log in to https://mycards.hdfc.bank.in using your registered mobile number </span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter the OTP configured to your registered mobile number</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Select &ldquo;Transactions&rdquo;</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Select &ldquo;Unbilled&rdquo; to view unbilled transactions</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            </li>
            </ol>
            <ol>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Net Banking:</span></span></span></p>
            </li>
            </ol>
            </ol>
            <p style="padding-left: 80px;"><span style=""><span style="" class="faqspan">On your HDFC Net Banking, go to </span></span><span style=""><span style="" class="faqspan"><span>Cards &gt;&gt; Enquire &gt;&gt; View Unbilled Transactions &gt;&gt; Select &ldquo;For Card No&rdquo; &gt;&gt; Select &ldquo;Transaction Type&rdquo; &gt;&gt; View</span></span></span><span style=""><span style="" class="faqspan">, to see the unbilled transactions</span></span></p>
            <ol>
            <ol start="3">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Mobile Banking:</span></span></span></p>
            </li>
            </ol>
            </ol>
            <p style="padding-left: 80px;"><span style=""><span style="" class="faqspan">On your HDFC Bank Mobile Banking app, go to </span></span><span style=""><span style="" class="faqspan"><span>Menu &gt;&gt; Pay &gt;&gt; Cards &gt;&gt; Card No. &gt;&gt; "Unbilled Transactions",</span></span></span><span style=""><span style="" class="faqspan"> to view the unbilled transactions.</span></span></p>
            <ol start="7">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How to view my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card credit card limit?</span></span></span></p>
            </li>
            </ol>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can view your Tata Neu HDFC Bank Credit Card credit limit by:</span></span></p>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Bank MyCards -</span></span></span></p>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">Log in to </span></span><span style="" class="faqspan">mycards.hdfc.bank.in</span><span style=""><span style="font-size: large;"> </span></span><span style=""><span style="" class="faqspan">using your registered mobile number</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Enter OTP sent to your registered mobile number</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can view your outstanding &amp; available credit limit</span></span></p>
            </li>
            </ol>
            </li>
            </ol>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Mobile Banking app: </span></span></span></p>
            </li>
            </ol>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">On your HDFC Bank Mobile Banking app, go to </span></span><span style=""><span style="" class="faqspan"><span>Menu &gt;&gt;Pay &gt;&gt; Cards &gt;&gt; Card No.</span></span></span><span style=""><span style="" class="faqspan">, you can view your outstanding &amp; available credit limit.</span></span></p>
            <p>&nbsp;</p>
            <ol start="3">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>HDFC Net Banking: </span></span></span></p>
            </li>
            </ol>
            <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">On your HDFC Net Banking, go to </span></span><span style=""><span style="" class="faqspan"><span>Cards &gt;&gt; Enquire &gt;&gt; Account Information &gt;&gt; For Card No. &gt;&gt; View,</span></span></span><span style=""><span style="" class="faqspan"> to view your total credit limit, available credit limit etc.</span></span></p>
            <p><br /><br /></p>
            <ol start="8">
            <li>
            <p align="left"><span style=""><span style="" class="faqspan"><span>How can I convert my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card transactions into EMI?</span></span></span></p>
            </li>
            </ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">You can convert both your online and in-store purchases into EMI from your Tata Neu HDFC Bank Credit Card using the HDFC Bank EASYEMI facility. To know more click here: https://www.hdfc.bank.in/easyemi/credit-card</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">You can also convert your transactions into EMI post the transaction using HDFC Bank SMARTEMI from your Tata Neu HDFC Bank Credit Card. To know more click here: To know more about SMARTEMI click here: </span></span><a style="color: white;" href="https://www.hdfc.bank.in/blogs/credit-cards"><span style=""><span style="" class="faqspan"><span lang="en-IN">https://www.hdfc.bank.in/blogs/credit-cards</span></span></span></a></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">This facility is available subject to eligibility as per bank internal policies and regulations.</span></span></p>
            </li>
            </ol>
            <p align="justify">&nbsp;</p>
            <ol start="9">
            <li>
            <p align="justify"><span style=""><span style="" class="faqspan"><span>How to enable/disable Autopay?</span></span></span></p>
            </li>
            </ol>
            <p><span style=""><span style="" class="faqspan">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; You can enable/ disable Autopay by HDFC Net Banking and HDFC Mobile Banking</span></span></p>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan"><span>To enable/disable Autopay from Net Banking:</span></span></span></p>
            </li>
            </ol>
            </ol>
            <ol>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">On your HDFC Net Banking, go to </span></span><span style=""><span style="" class="faqspan"><span>Cards &gt;&gt; Request &gt;&gt; Autopay Register to enable Autopay / Autopay de-register</span></span></span><span style=""><span style="" class="faqspan"> to disable Autopay</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Select the type of amount to be paid (Minimum/Total/Other).</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Click on "Continue" and then click on "Confirm" to enable /disable the Autopay.</span></span></p>
            </li>
            </ol>
            </ol>
            </ol>
            <p>&nbsp;</p>
            <ol>
            <ol start="2">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>To enable/disable Autopay from Mobile Banking:</span></span></span></p>
            </li>
            </ol>
            </ol>
            <ol>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">On your HDFC Mobile Banking app, go to </span></span><span style=""><span style="" class="faqspan"><span>Menu &gt;&gt; Pay &gt;&gt; Cards &gt;&gt; Card No. &gt;&gt; Account No. &gt;&gt;Scroll down to "Credit Card Bill"&gt;&gt; Enable/Disabled </span></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Select the type of amount to be paid (Minimum/Total/Other)</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Click on "Continue" and then click on "Confirm" to enable /disable the Autopay.</span></span></p>
            </li>
            </ol>
            </ol>
            </ol>
            </ol>
            </ol>
            <p class="western"><br /><br /></p>
            <ol start="10">
            <li>
            <p><span style=""><span style="" class="faqspan"><span>How do I dispute a transaction on Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card?</span></span></span></p>
            </li>
            </ol>
            <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You can raise the dispute transaction complaint as follows:</span></span></p>
            <ol>
            <ol>
            <li>
            <p><span style=""><span style="" class="faqspan">You can click here to report a transaction dispute <a style="color: white;" href="https://apply.hdfcbank.com/digital/onlinedispute%23odrlogin">https://apply.hdfcbank.com/digital/onlinedispute#odrlogin</a></span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">To report dispute transaction on your Tata Neu HDFC Bank Credit Card please contact HDFC bank Phone Banking from your registered mobile/email.</span></span></p>
            </li>
            <li>
            <p><span style=""><span style="" class="faqspan">Please note that transaction complaints can be raised only within 30 days from the statement date.</span></span></p>
            </li>
            </ol>
            </ol>
            <p class="western"><br /><br /></p>`
      }
    ]
  },
  {
    header: 'Rewards on Tata Neu HDFC Bank Credit Card',
    data: [
      {
        header: '',
        data: `
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan"><span>How do I earn NeuCoins on my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit Card purchases?</span></span></span></p>
          </li>
          </ol>
          <div class="tablediv">
          <table width="100%" cellspacing="0" cellpadding="7">
          <tbody>
          <tr>
          <td style="" width="191" height="27">
          <p class="western" align="justify"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>Categories</span></span></span></span></p>
          </td>
          <td style="" width="247">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>NeuCard Infinity</span></span></span></span></p>
          </td>
          <td style="" width="86">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>NeuCard Plus </span></span></span></span></p>
          </td>
          </tr>
          <tr>
          <td style="" width="191" height="7">
          <p class="western" align="justify"><span style="color: #000000;"><span style=""><span style="" class="tableBody">Tata Neu</span></span></span></p>
          </td>
          <td style="" width="247">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">5%</span></span></span></p>
          </td>
          <td style="" width="86">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">2%</span></span></span></p>
          </td>
          </tr>
          <tr>
          <td style="" width="191" height="7">
          <p class="western" align="justify"><span style="color: #000000;"><span style=""><span style="" class="tableBody">Partner Tata Brands (Online and In-store Purchases)</span></span></span></p>
          </td>
          <td style="" width="247">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">5%</span></span></span></p>
          </td>
          <td style="" width="86">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">2%</span></span></span></p>
          </td>
          </tr>
          <tr>
          <td style="" width="191" height="6">
          <p class="western" align="justify"><span style="color: #000000;"><span style=""><span style="" class="tableBody">Other Spends</span></span></span></p>
          </td>
          <td style="" width="247">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">1.50%</span></span></span></p>
          </td>
          <td style="" width="86">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">1%</span></span></span></p>
          </td>
          </tr>
          </tbody>
          </table>
          </div>
          <p class="western" align="justify">&nbsp;</p>
          <p class="western" style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan"><span>Exception</span></span></span></p>
          <ol>
          <ol>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Fuel, government, rental, post-transaction EMI conversion and wallet load transactions are not eligible for earning NeuCoins.</span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Base Reward points earned on Grocery transactions will be capped to 1,000 NeuCoins per month for Tata Neu Plus HDFC Bank Credit card. Accelerated Rewards points on eligible transactions will be unlimited subjected to FUP. <br/>
          For Fair Usage policy kindly visit: <a style="color: white;" href="https://www.hdfc.bank.in/credit-cards/tata-neu-plus-hdfc-bank-credit-card" target="_blank" rel="noopener noreferrer">Fair Usage Policy</a>
          </span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Base Reward points earned on Grocery transactions will be capped to 2,000 NeuCoins per month for Tata Neu Infinity HDFC Bank Credit card. Accelerated Rewards points on eligible transactions will be unlimited subjected to FUP. <br/>
          For Fair Usage policy kindly visit: <a style="color: white;" href="https://www.hdfc.bank.in/credit-cards/tata-neu-infinity-hdfc-bank-credit-card" target="_blank" rel="noopener noreferrer">Fair Usage Policy</a>
          </span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Fuel surcharge waiver on Tata Neu Plus HDFC Bank Credit Card will be capped at ₹250 per month at all fuel stations across India. (on minimum transaction of ₹400 & maximum transaction of ₹5,000)<br/>
          To know more, kindly visit: <a style="color: white;" href="https://www.hdfc.bank.in/credit-cards/tata-neu-plus-hdfc-bank-credit-card" target="_blank" rel="noopener noreferrer">www.hdfc.bank.in</a>
          </span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Fuel surcharge waiver on Tata Neu Infinity HDFC Bank Credit Card will be capped at ₹500 per month at all fuel stations across India. (on minimum transaction of ₹400 & maximum transaction of ₹5,000)<br/>
          To know more, kindly visit: <a style="color: white;" href="https://www.hdfc.bank.in/credit-cards/tata-neu-infinity-hdfc-bank-credit-card" target="_blank" rel="noopener noreferrer">www.hdfc.bank.in</a>
          </span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Currently, Bill Payment (Tata Pay), Air India, Tata Play spends are not eligible for additional 5% NeuCoins via NeuPass Membership.
          </span></span></p>
          </li>
          </ol>
          </ol>
          <p class="western" style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan"><span>Partner Tata Brands</span></span></span><span style=""><span style="" class="faqspan"> Croma (Infiniti Retail Private Limited), bigbasket (Innovative Retail Private Limited), Westside, Tata 1mg, Air Asia, Tata CliQ, IHCL (Taj Hotels, Vivanta Hotels, President IHCL Select, Ginger hotels, Piem Hotels), Qmin, Tata Play, Tata Pay, Cult (Cultfit, Curefit), Titan (Eyeplus, Taneira, Titan, Fastrack, Helios, World of Titan ) effective on all the transaction done post 1st January 2023, Tanishq (Titan Company Ltd.,Tanishq, Caratlane, Mia, Zoya) effective on all the transaction done post 1st January 2023, Air India effective on all the transaction done post 1st October 2023.</span></span></p>
          
          <ol start="2">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>How can I check that how my NeuCoins / reward points I have earned on my Neu</span></span></span><span style=""><span style="" class="faqspan"> HDFC Bank Credit </span></span><span style=""><span style="" class="faqspan"><span>Card on Tata Neu?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">The NeuCoins earned on your purchases done via Tata Neu HDFC Bank Credit Card will be credited to Tata Neu in 7 working days post your billing statement generation. </span></span></p>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan"><span>Steps to view your NeuCoins balance:</span></span></span></p>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Visit </span></span><span style=""><span style="" class="faqspan"><span>Tata Neu Home Page &gt;&gt; NeuPass &gt;&gt; View details</span></span></span><span style=""><span style="" class="faqspan">, you can check the Narration:</span></span> <span style=""><span style="" class="faqspan">&ldquo;Tata Neu HDFC Bank Credit Card &ndash;&nbsp;Last billing cycle&nbsp;NeuCoins&rdquo;</span></span></p>
          <ol start="3">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>Where can I use my NeuCoins?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style="" class="faqspan">You can use your accumulated NeuCoins (1 NeuCoin = 1 Rupee) for your purchases at Partner Tata Brand websites / Mobile App / At Stores. The applicable Partner Tata Brands and redemption process is tabulated below.</span></p>
          <p>&nbsp;</p>
          <table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
	<tbody>
		<tr>
			<td colspan="3">
			<p>REDEMPTION ON MOBILE APP / WEBSITE</p>
			</td>
		</tr>
		<tr>
			
			<td style="vertical-align:top">
			<p><span style="" class="faqspan">How to redeem?</span></p>
			</td>
			<td style="vertical-align:top">
			<p style="text-align:center;"><span style="text-align:center;" class="faqspan">Applicable Brands</span></p>
			</td>
		</tr>
		<tr>
		
			<td>
			<p>via Tata Pay</p>

			<ol start="1" style="list-style-type:decimal">
				<li><span style="" class="faqspan">Select &lsquo;Tata Pay&rsquo; as payment option on payments page</span></li>
				<li><span style="" class="faqspan">Redeem desired amount of &lsquo;NeuCoins&rsquo; on Tata Pay</span></li>
			</ol>
			</td>
			<td>
			<ol start="1" style="list-style-type:decimal">
				<li><span style="" class="faqspan">Tata Neu</span></li>
				<li><span style="" class="faqspan">AirAsia India</span></li>
				<li><span style="" class="faqspan">bigbasket</span></li>
				<li><span style="" class="faqspan">Croma</span></li>
				<li><span style="" class="faqspan">IHCL hotels</span></li>
			</ol>
			</td>
		</tr>
		<tr>
		
			<td>
			<p>via &lsquo;NeuCoins&rsquo; / &lsquo;Use my NeuCoins&rsquo; / &lsquo;Loyalty Redemption&rsquo;</p>

			<ol start="1" style="list-style-type:decimal">
				<li><span style="" class="faqspan">Select &lsquo;NeuCoins&rsquo; / &lsquo;Use my NeuCoins&rsquo; / &lsquo;Loyalty Redemption&rsquo; option on order page / payments page</span></li>
				<li><span style="" class="faqspan">Redeem the desired amount of NeuCoins</span></li>
			</ol>
			</td>
			<td>
			<ol start="1" style="list-style-type:decimal">
				<li><span style="" class="faqspan">Tata Cliq</span></li>
				<li><span style="" class="faqspan">Tata 1mg</span></li>
        <li><span style="" class="faqspan">Titan (via Tata Neu)</span></li>
        <li><span style="" class="faqspan">Tanishq (via Tata Neu)</span></li>
			</ol>
			</td>
		</tr>
	</tbody>
</table>

<p>&nbsp;</p>

<table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">
	<tbody>
		<tr>
			<td colspan="3">
			<p>REDEMPTION AT STORES</p>
			</td>
		</tr>
		<tr>
			
			<td>
			<p><span style="" class="faqspan">How to redeem?</span></p>
			</td>
			<td>
			<p style="text-align:center;"><span style="text-align:center;" class="faqspan">Applicable Brands</span></p>
			</td>
		</tr>
		<tr>
		
			<td>
			<p>At Point of Sale / Cashier Desk</p>

			<ol start="1" style="list-style-type:decimal">
				<li><span style="" class="faqspan">Voice out your Tata Neu Registered Mobile number to the cashier</span></li>
				<li><span style="" class="faqspan">The cashier will confirm the NeuCoins balance on your Tata Neu account</span></li>
				<li><span style="" class="faqspan">Confirm the amount of NeuCoins to be redeemed</span></li>
				<li><span style="" class="faqspan">Cashier will trigger an OTP to your registered mobile number to initiate redemption</span></li>
				<li><span style="" class="faqspan">Voice out the OTP to the cashier to complete your purchase using NeuCoins</span></li>
			</ol>
			</td>
			<td>
			<ol start="1" style="list-style-type:decimal">
				<li><span style="" class="faqspan">Croma</span></li>
				<li><span style="" class="faqspan">IHCL hotels</span></li>
			</ol>
			</td>
		</tr>
	</tbody>
</table>

<ul><li>
<p><span style=""><span style="" class="faqspan"><b>Note-</b> Currently, NeuCoins redemption option is not available on Air India, Tata Play, and Bill Payment on Tata Neu
</span></span></p>
</li></ul>

          
          <ol start="4">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is the validity of NeuCoins?</span></span></span></p>
          </li>
          </ol>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">NeuCoins earned on your Tata Neu HDFC Bank Credit Card are valid for 365 days from the date they are credited to your Tata Neu account.</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">During special promotions or offers, you might also earn additional NeuCoins. The expiry of these NeuCoins will be mentioned at the time of issuance.</span></span></p>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">The NeuCoins earned as part of Tata Neu HDFC Bank Credit Card welcome benefit has an expiry date of 365 days only.</span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <ol start="5">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What is the value of 1 NeuCoin?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Each NeuCoin is worth ₹1 and can be used seamlessly across eligible Tata brands.</span></span></p>
          <ol start="6">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What happens when NeuCoins are not credited in real time for previous transactions?</span></span></span></p>
          </li>
          </ol>
          <ul>
          <li style="list-style-type: none;">
          <ul>
          <li>
          <p class="faqspan">Your monthly statement will give breakup of NeuCoins as following:</p>
          <ul>
          <li>
          <p class="faqspan">NeuCoins accrued and available with the Bank</p>
          </li>
          <li>
          <p class="faqspan">NeuCoins transferred to Tata Neu during the Statement Cycle</p>
          </li>
          </ul>
          </li>
          </ul>
          </li>
          </ul>
          <ul>
          <li style="list-style-type: none;">
          <ul>
          <li>
          <p><span style=""><span style="" class="faqspan"><span>The closing balance of the Tata NeuCoins as reflected in the statement, </span></span></span><span style=""><span style="" class="faqspan">will be credited to your Tata Neu in 7 working days from your billing statement generation. </span></span></p>
          </li>
          </ul>
          </li>
          </ul>
          <p class="western" style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan"><span>Explainer:</span></span></span><span style=""><span style="" class="faqspan"> If your billing cycle is 2</span></span><sup><span style=""><span style="" class="faqspan">nd</span></span></sup><span style=""><span style="" class="faqspan">-June-22 to 1</span></span><sup><span style=""><span style="" class="faqspan">st</span></span></sup><span style=""><span style="" class="faqspan">-July-22 and your billing statement date is 1</span></span><sup><span style=""><span style="" class="faqspan">st</span></span></sup><span style=""><span style="" class="faqspan">-July-22, then the following will happen, and points will be available on Tata Neu by 8</span></span><sup><span style=""><span style="" class="faqspan">th</span></span></sup><span style=""><span style="" class="faqspan"> July-22:</span></span></p>
          <div class="tablediv">
          <table width="100%" cellspacing="0" cellpadding="1">
          <tbody>
          <tr>
          <td style="" width="66" height="3">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>Statement Cycle</span></span></span></span></p>
          </td>
          <td style="" width="134">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>Transactions in Statement</span></span></span></span></p>
          </td>
          <td style="" width="156">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>Reward Points</span></span></span></span></p>
          </td>
          <td style="" width="235">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>Period of Transaction Considered for Accrual of Reward Points</span></span></span></span></p>
          </td>
          </tr>
          <tr valign="top">
          <td style="" rowspan="2" width="66" height="3">
          <p class="western" align="center"><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody"><span>1st Jul</span></span></span></span></p>
          </td>
          <td style="" rowspan="2" width="134">
          <p class="western"><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody">Transactions having settlement date between </span></span></span><br /><span style=""><span style="" class="tableBody"><span>2nd Jun - 1st Jul</span></span></span></span></p>
          </td>
          <td style="" width="156">
          <p class="western"><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody">Base NeuCoins</span></span></span></p>
          </td>
          <td style="" width="235">
          <p class="western"><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody">Transactions having settlement date<br />between </span></span></span><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody"><span>2nd Jun - 1st Jul</span></span></span></span></p>
          </td>
          </tr>
          <tr>
          <td style="" valign="top" width="156">
          <p class="western"><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody">Additional NeuCoins on partner Tata Brand Transactions </span></span></span></p>
          </td>
          <td style="" valign="top" width="235">
          <p class="western"><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody">Transactions having settlement date <br />between </span></span></span><span style=""><span style=""><span style="" class="tableBody"><span>1st Jun - 30th Jun<br /></span></span></span></span><span style="color: #E3E3E3;"><span style=""><span style="" class="tableBody">(For transaction settled on 1st Jul, Accelerated Points will be posted in 1st Aug statement cycle)</span></span></span></p>
          </td>
          </tr>
          </tbody>
          </table>
          </div>
          <p class="western" align="justify">&nbsp;</p>
          <div class="tablediv">
          <table width="100%" cellspacing="0" cellpadding="7">
          <tbody>
          <tr valign="top">
          <td style="" width="162" height="14">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>For Eligible Transactions</span></span></span></span></p>
          </td>
          <td style="" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>Tata Neu Plus HDFC Bank Credit Card</span></span></span></span></p>
          </td>
          <td style="" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>Tata Neu Infinity HDFC Bank Credit Card</span></span></span></span></p>
          </td>
          </tr>
          <tr valign="top">
          <td style="" bgcolor="#bdd7ee" width="162" height="1">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span>Base NeuCoins</span></span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">1%</span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">1.5%</span></span></span></p>
          </td>
          </tr>
          <tr valign="top">
          <td style="" bgcolor="#bdd7ee" width="162" height="1">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span>Additional NeuCoins on Partner</span></span></span></span><br /><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span>Tata Brand Transactions</span></span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">additional 1%</span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">additional 3.5%</span></span></span></p>
          </td>
          </tr>
          </tbody>
          </table>
          </div>
          <p class="western" align="justify">&nbsp;</p>
          <ol start="7">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>What to do if rewards on the Tata Neu HDFC Bank Credit Card are not received?</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span></span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span></span></span></span></p>
          </li>
          </ol>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p><span style=""><span style="" class="faqspan">If you have not received your NeuCoins on your Tata Neu HDFC Bank Credit Card transactions, kindly contact HDFC Bank from your registered mobile / email on below contacts:</span></span></p>
          <ul><li><span  class="faqspan">Tata Neu HDFC Bank Customer Care Number: 1800-25-8282-638</span>
          </li>
          <li><span  class="faqspan">
          Tata Neu HDFC Bank Customer Care Email-Id: <a style="color: white;" href="mailto:customerservices.cards@hdfc.bank.in">customerservices.cards@hdfc.bank.in</a>
          </span>
          </li>
          </ul>
          </li>
          <li>
          <p><span style=""><span style="" class="faqspan">If you have not received your Tata Neu HDFC Bank Credit Card welcome benefit NeuCoins or 5% NeuCoins as part of NeuPass membership benefit, then please reach out to Tata Neu Customer Service from your registered account / email at the contact mentioned below:
          <ul><li><span  class="faqspan">Chat - You can chat with us from the help section on the Tata Neu app</span>
          </li>
          <li><span  class="faqspan">
          Email id - <a style="color: white;" href="mailto:customercare@tataneu.com">customercare@tataneu.com</a>
          </span>
          </li>
          </ul></span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <ol start="8">
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan"><span>What to do when incorrect NeuCoins are credited for your Tata Neu HDFC Bank Credit Card transactions?</span></span></span></p>
          </li>
          </ol>
          <p class="western" style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan">If your transactions are incorrectly rewarded with NeuCoins, then to report issue of calculation of NeuCoins against your Tata Neu HDFC Bank Credit Card transactions please reach out to the HDFC Bank Phone Banking from your bank registered mobile number/email.</span></span></p>
          <ol start="9">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>I want to know about complimentary airport lounge access program and participating airport lounges on my Tata Neu HDFC Bank Credit Card</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan">You will have access to domestic &amp; international lounges with Tata Neu HDFC Bank Credit Card</span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Tata Neu Plus HDFC Bank Credit Card: 1 domestic lounge access per quarter</span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Tata Neu Infinity HDFC Bank Credit Card: 2 Domestic lounge access per quarter and 1 international lounge access per quarter</span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <p class="western" style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan"><span>Explainer: </span></span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">If you are using Tata Neu Infinity HDFC Bank RuPay Credit Card, then you can check the list of participating lounges below:</span></span></p>
          <ol type="a">
          <li>
          <p><span style=""><span style="" class="faqspan">Domestic airport lounges: <a style="color: white;" href="https://info.dreamfolks.in/partner-lounges?filter=YTdnaXh2ZGhKUWIzVFQyVGd6SitIUT09">https://info.dreamfolks.in/partner-lounges?filter=YTdnaXh2ZGhKUWIzVFQyVGd6SitIUT09</a></span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">International airport lounges: <a style="color: white;" href="https://www.rupay.co.in/lounges">https://www.rupay.co.in/lounges</a></span></span></p>
          </li>
          </ol>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">If you are using Tata Neu Infinity HDFC Bank VISA Credit Card, then you can check the list of participating lounges below:</span></span></p>
          <ol type="a">
          <li>
          <p><span style=""><span style="" class="faqspan">Domestic airport lounges: <a style="color: white;" href="https://info.dreamfolks.in/partner-lounges?filter=YTdnaXh2ZGhKUWIzVFQyVGd6SitIUT09">https://info.dreamfolks.in/partner-lounges?filter=YTdnaXh2ZGhKUWIzVFQyVGd6SitIUT09</a></span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Priority Pass airport lounges: <a style="color: white;" href="https://www.prioritypass.com/%20">https://www.prioritypass.com/</a> </span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          </li>
          </ol>
          <ol start="10">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>I want to know about Priority Pass Membership program and when will I get my Priority Pass.</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan">You will get your Priority Pass Card in your bank registered address after your Tata Neu Infinity HDFC Bank VISA Credit Card application is approved. The Priority Pass Card is valid for 3 years from the date of issue. The Priority Pass can be used at 1000+ airport lounges in more than 90 countries.</span></span></p>
          <p style="padding-left: 40px;" align="justify"><span style=""><span style="" class="faqspan"><span>Explainer:</span></span></span></p>
          <ol>
          <li style="list-style-type: none;">
          <ol>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Your Priority Pass Card allows 1 free access per calendar quarter.</span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Lounge Visits outside India exceeding the complimentary visits will be charged at US $27 + GST as applicable.</span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">All guests visit using Priority pass would be charged at US $27 + GST per visit per guest.</span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Charges will be billed to your credit card statement within 90 days of Lounge visit </span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Any lounge visits out of priority pass network will be chargeable as per the discretion of the respective lounges.</span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Primary and add on priority pass member can jointly enjoy the complimentary cap on priority pass (add on to swipe their own priority pass to avail the complimentary benefit). </span></span></p>
          </li>
          <li>
          <p align="justify"><span style=""><span style="" class="faqspan">Any Lounge visit within India using Priority Pass will be charged at US $27 + GST as applicable</span></span></p>
          </li>
          </ol>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">The currency conversion rate will be applicable as per the prevailing rate on billing date</span></span></p>
          <ol start="11">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>My Tata Neu HDFC Bank Credit Card are not getting rewarded additional NeuCoins. </span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">If your transactions are not getting rewarded with additional NeuCoins/bonus NeuCoins, then to report issue in calculation of NeuCoins against your Tata Neu HDFC Bank Credit Card transactions please reach out to the HDFC Bank Phone Banking from your bank registered mobile number/ bank registered mail-id.</span></span></p>
          <ol start="12">
          <li>
          <p><span style=""><span style="" class="faqspan"><span>Do I earn NeuCoins on Txn's done on Air India Website/POS using my Tata Neu HDFC Bank Credit Card?</span></span></span></p>
          </li>
          </ol>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Yes, all eligible transactions conducted on the Air India website/app or at any Air India point of sale (POS) for services such as flight bookings, in-flight purchases, and any other products or services offered by Air India on or after 1st October will be eligible for NeuCoins accrual. The NeuCoins earning rate will be as follows:
          <div class="tablediv">
          <table width="100%" cellspacing="0" cellpadding="7">
          <tbody>
          <tr valign="top">
          <td style="" width="162" height="14">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>Categories</span></span></span></span></p>
          </td>
          <td style="" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>NeuCard Infinity</span></span></span></span></p>
          </td>
          <td style="" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableHeading"><span>NeuCard Plus</span></span></span></span></p>
          </td>
          </tr>
          <tr valign="top">
          <td style="" bgcolor="#bdd7ee" width="162" height="1">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span>Air India</span></span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">5%</span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">2%</span></span></span></p>
          </td>
          </tr>
          </tbody>
          </table>
          </div>
          <br/>
          <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan"><b><u>Note-</u></b> The above rewards will be in addition to any applicable benefits through Air India Flying Returns loyalty program, according to your membership status. </span></span></p>
          </span></span></p>
          `}
    ]
  },
  {
    header: 'Managing Tata Neu HDFC Bank Credit Card',
    data: [
      {
        header: '',
        data: `<ol>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>How can I contact HDFC Bank Phone Banking / Customer Service?</span></span></span></p>
              </li>
              </ol>
              <ol>             
              <p><span style=""><span style="" class="faqspan">To contact HDFC bank Phone Banking please call at the contacts below, from your registered mobile/email:</span></span></p>
              <ol>
              <li>
              <p><span style=""><span style="" class="faqspan">In India: Call 1800-25-8282-638 </span></span></p>
              </li>
              <li>
              <p><span style=""><span style="" class="faqspan">Travelling Overseas: Call +91-22-6160-6160</span></span></p>
              </li>
              <li>
              <p><span style=""><span style="" class="faqspan">For non-dispute related queries, please email to: </span></span><a style="color: white;" href="mailto:customerservices.cards@hdfc.bank.in"><span style=""><span style="" class="faqspan"><span lang="en-IN">customerservices.cards@hdfc.bank.in</span></span></span></a></p>
              </li>
              <li>
              <p><span style=""><span style="" class="faqspan">For dispute related queries, please email to: </span></span><a style="color: white;" href="../home/tuneer/Downloads//C:/Users/janmajoy.tripathy/AppData/Local/Microsoft/Windows/INetCache/Content.Outlook/EVLIYQCB/cc.disputes@hdfc.bank.in"><span style=""><span style="" class="faqspan"><span lang="en-IN">cc.disputes@hdfc.bank.in</span></span></span></a></p>
              </li>
              </ol>
              </li>
              </ol>
              <ol start="2">
              <li>
              <p><span style=""><span style="" class="faqspan"><span>How can I contact Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>HDFC Bank Credit</span></span></span><span style=""><span style="" class="faqspan"> </span></span><span style=""><span style="" class="faqspan"><span>Card Customer Service?</span></span></span></p>
              </li>
              </ol>
              <ol>                        
              <p><span style=""><span style="" class="faqspan">To contact Tata Neu HDFC Bank Credit Card Customer Service, please chat or write to the contacts below from your registered account/email:</span></span></p>              
              <ol><li>
              <p align="justify"><span style=""><span style="" class="faqspan">Chat - You can chat with us from the help section on the Tata Neu app</span></span></p>
              </li>
              <li>
              <p align="justify"><span style=""><span style="" class="faqspan">Email-Id: <a style="color: white;" href="mailto:customerservices.cards@hdfc.bank.in">customerservices.cards@hdfc.bank.in</a></span></span></p>
              </li>
              </ol>
              </li>
              </ol>
              <ol start="3">
              <li>
              <p><span style=""><span style="" class="faqspan"><span>What are the ways in which I can view my Tata Neu</span></span></span><span style=""><span style="" class="faqspan"> HDFC Bank Credit </span></span><span style=""><span style="" class="faqspan"><span>Card statement?</span></span></span></p>
              </li>
              </ol>
              <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">You will receive the monthly statement on your registered email id as per your registration for e-statements. Alternatively, you can also get your previous HDFC Bank Tata Neu HDFC Bank Credit Card bill statement as follows:</span></span></p>
              <ol>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>HDFC Bank mycards -</span></span></span></p>
              </li>
              </ol>
              <ol>
              <ol>
              <li>
              <p><span style=""><span style="" class="faqspan">Login to mycards.hdfc.bank.in using your registered mobile number.</span></span></p>
              </li>
              <li>
              <p><span style=""><span style="" class="faqspan">Enter OTP sent to your registered mobile number. </span></span></p>
              </li>
              <li>
              <p><span style=""><span style="" class="faqspan">Click on e-statement and select month to generate your statement. Your billed statement for that month will be sent to your registered email-ID.</span></span></p>
              </li>
              </ol>
              </ol>
              <ol start="2">
              <li>
              <p><span style=""><span style="" class="faqspan"><span>HDFC Net Banking: </span></span></span></p>
              </li>
              </ol>
              <p style="padding-left: 40px;"><span style=""><span style="" class="faqspan">On HDFC Bank Net Banking, go to </span></span><span style=""><span style="" class="faqspan"><span>Cards &gt;&gt; Enquire &gt;&gt; View Statement &gt;&gt; Card No. &gt;&gt; Period &gt;&gt; view/download statement</span></span></span><span style=""><span style="" class="faqspan"> to view your Tata Neu HDFC Bank Credit Card Statement.</span></span></p>
              <ol start="3">
              <li>
              <p><span style=""><span style="" class="faqspan"><span>HDFC Mobile Banking app: </span></span></span></p>
              </li>
              </ol>
              <p style="padding-left: 80px;"><span style=""><span style="" class="faqspan">On HDFC Bank Mobile Banking app, go to </span></span><span style=""><span style="" class="faqspan"><span>Menu &gt;&gt; Pay &gt;&gt; Cards &gt;&gt; Card No.&gt;&gt; Scroll down to &lsquo;Actions&rsquo; &gt;&gt; Duration &gt;&gt; Download</span></span></span><span style=""><span style="" class="faqspan">, to view your Tata Neu HDFC Bank Credit Card Statement</span></span></p>
              <p class="western" style="padding-left: 40px;"><span style=""><span style="" class="faqspan">Alternatively, you can also request for your previous statements by calling HDFC Bank phone banking from your registered mobile number / email.</span></span></p>`
      }
    ]
  },
  {
    header: 'About Existing HDFC Credit Card Holder',
    data: [
      {
        header: '',
        data: `<ol>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>I am an existing HDFC card holder can I apply for this card?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">Existing HDFC Bank Credit Card holders can also apply for this Card. The Credit Limit of existing HDFC Bank Credit Card will be shared with the Tata Neu HDFC Bank Credit Card.</span></span></p>    
              <li>
              <p><span style=""><span style="" class="faqspan"><span>There is a difference between the card limit shown to me on approval page and the final limit I have received?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">We will honour the limit shown to the customer on the approval screen. In case of an existing HDFC Bank Credit Card holder the initial limit post card creation will be ₹ 5000. The limit will be reset to your existing card limit in 5 working days from your card issuance date and will be shared across both the cards.</span></span></p>
              </ol>
              `
      }
    ]
  },
  {
    header: 'Linking Rupay Credit Card on BHIM UPI',
    data: [
      {
        header: '',
        data: `<ol>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>Can I link my Tata Neu HDFC Bank Credit Card with UPI?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">Yes, you can link your Tata NEU HDFC Bank Rupay credit card on BHIM app.</span></span></p>    
              <li>
              <p><span style=""><span style="" class="faqspan"><span>What are the steps to link my Rupay credit card on BHIM app?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan"><span><u>Step 1:</u> Please download BHIM app from Google Play store/App Store.</span><br/>

              <span><u>Step 2:</u> Complete the registration journey using the mobile number with which your credit card account is linked.</span><br/>
              
              <span><u>Step 3:</u> Select Credit Card as an option in the Add account section or click on the banner for linking Rupay card on homepage.</span><br/>
              
              <span><u>Step 4:</u> Select your issuing bank name from the drop down.</span><br/>
              
              <span><u>Step 5:</u> Basis the mobile number update with your issuing bank, masked Credit Cards will appear on the screen.</span><br/>
              
              <span><u>Step 6:</u> Select the card which you want to link and confirm. Proceed to generate UPI PIN.</span></span></span></p>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>Can I make payment to any person or other Credit Card using the linked Credit Card on UPI?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">No, only payment to merchant (P2M) will be allowed from the linked Credit Card.</span></span></p>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>Will I earn any NeuCoins for UPI spends using HDFC Bank RuPay Credit Card?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">Yes, UPI spends using Credit Card will earn NeuCoins (Excluding categories as per Credit Card product features/Terms & Conditions).
             <br/>
              Refer below table for detailed reward points structure on HDFC Bank RuPay Credit Cards.</span></span></p>
              <table width="100%" cellspacing="0" cellpadding="7">
          <tbody>
          <tr valign="top">
          <td style="" width="162" height="14">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>Product Name</span></span></span></span></p>
          </td>
          <td style="" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>Tata Neu UPI ID</span></span></span></span></p>
          </td>
          <td style="" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style=""  class="tableHeading"><span>Other UPI ID</span></span></span></span></p>
          </td>
          </tr>
          <tr valign="top">
          <td style="" bgcolor="#bdd7ee" width="162" height="1">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span>Tata Neu Plus HDFC Bank Credit Card</span></span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">1% back as NeuCoins <br/>(including spends on partner Tata Brands</span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="191">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">0.25% back as NeuCoins on other UPI Spends</span></span></span></p>
          </td>
          </tr>
          <tr valign="top">
          <td style="" bgcolor="#bdd7ee" width="162" height="1">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span>Tata Neu Infinity HDFC Bank Credit
          Card</span></span></span></span><br /><span style="color: #000000;"><span style=""><span style="" class="tableBody"><span></span></span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">1.5% back as NeuCoins <br/>(including spends on partner Tata Brands)</span></span></span></p>
          </td>
          <td style="background: #E3E3E3f;" bgcolor="#E3E3E3f" width="204">
          <p class="western" align="center"><span style="color: #000000;"><span style=""><span style="" class="tableBody">0.5% back as NeuCoins on other UPI Spends</span></span></span></p>
          </td>
          </tr>
          </tbody>
          </table>
          <li>
          <p><span style=""><span style="" class="faqspan"><span>Is there any capping on the reward points that can be earned on UPI spends through RuPay Credit Cards?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">Maximum of 700 NeuCoins can be earned in a calendar month on UPI spends through RuPay Credit Card.</span></span></p>
              </ol>
              `
      }
    ]
  },
  {
    header: 'Credit Card Referral Program',
    data: [
      {
        header: '',
        data: `<ol>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>What is NeuCard Refer and earn?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">Under the NeuCard Refer and earn, the existing Tata Neu HDFC Bank Credit card holders (known as 'referrer') can refer their friends & family to apply for NeuCard & earn 1000 NeuCoins (1 NeuCoin = ₹1) within 90 days from the date of successful card issuance of the referee.
              <br/></span></span></p>    
              <li>
              <p><span style=""><span style="" class="faqspan"><span>How do I refer someone to NeuCard?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan"><span>NeuCard customers can share their referral link/code with their family or friends through SMS, Email, WhatsApp and other social media channels.</span></span></span></p>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>How many referrals can I make?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">There is no limit to the number of referrals that can be made. However, eligible customers can earn rewards with a maximum earning of 3,00,000 NeuCoins in a calendar month.</span></span></p>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>How and when will the referral reward be processed?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">

The referral reward of 1000 NeuCoins (per Successful Referral) will be credited within 90 days from the date of successful card issuance of the referee. You will be notified through SMS once 1000 NeuCoins are credited.              
              
              </span></span></p>        
          <li>
          <p><span style=""><span style="" class="faqspan"><span>I referred successfully but did not receive 1000 NeuCoins in my account yet, what should I do?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">If you have not received your referral reward of 1000 NeuCoins within 90 days, please check that <br/>
              - The person you referred has used your referral link/ code to apply for NeuCard<br/>

              - Their credit card has been issued<br/>
              
              - 90 days have been completed since referee's card issue date.<br/>
              If everything has been checked and timeline has been crossed, please share the referee's mobile number with the customer care team for further assistance at customercare@tataneu.com.</span></span></p>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>Where should I enter my referral code for NeuCard Refer and earn?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">You can apply your referral code by following the below process:</span></span></p>
              <p><span style=""><span style="" class="faqspan">Visit <b>Tata Neu Home Page >> Click on Finance section >> Click on Credit cards</b>. You can enter the referral code at the bottom of the Personal details page while applying for NeuCard.</span></span></p>
              <li>
              <p><span style=""><span style="" class="faqspan"><span>What are the terms and conditions for NeuCard Refer and earn?</span></span></span></p>
              </li>
              <p><span style=""><span style="" class="faqspan">You can view the terms and conditions for NeuCard Refer and earn by following below process:
<br/>
              Visit <b>Tata Neu Home Page >> Click on the profile icon (on the top-right of the homepage) >> Click on Legal  >> Click on “NeuCard Refer and earn” tab.</b></span></span></p>
              </ol>
              `
      }
    ]
  }
]
